<script lang="ts">
  import type {
    IFormHiddenFieldNode,
    PartialNode,
  } from "@shared/common/node/type";
  import type { IUserData } from "@shared/common/types/data-source";
  import { generateHiddenFieldDataName } from "@shared/common/utils/form";
  import detectReaction from "../../actions/detect-reaction";
  import { getCurrentDocumentNode, getStore } from "../../context";

  const { reactionEventListener, dataMap } = getStore();

  const documentNode = getCurrentDocumentNode();

  export let node: PartialNode<IFormHiddenFieldNode>;

  $: userData = ($dataMap.user?.data ?? {}) as IUserData["data"];
</script>

<div
  use:detectReaction={{
    node,
    onAction: reactionEventListener,
    documentNode,
  }}
>
  {#each node.fields ?? [] as field}
    <input
      name={generateHiddenFieldDataName(field)}
      type="hidden"
      value={userData[field] ?? ""}
    />
  {/each}
</div>
